declare global {
  interface Window {
    ace: any
    MSStream: any
  }
  interface ace {
    Editor: any
  }
}
import loadScriptInBody from '@/services/loadScriptInBody.service'
import { useIdeStore } from '@/stores/embeds/ide.store'

/**
 * Clean the ide store
 */
const cleanIdeStore = () => {
  useIdeStore().$reset()
}
/**
 * Fix ace editor bug on ios
 */
const fixAceeIOSBug = () => {
  if (
    typeof navigator === 'object' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !window.MSStream
  ) {
    window.MSStream = {}
  }
}

/**
 * Initialize the embed code editor
 */
const injectAce = () => {
  fixAceeIOSBug()
  // inject nessary scripts
  loadScriptInBody.loadScriptInBody('/assets/javascript/ace.min.js').then(async () => {
    loadScriptInBody.loadScriptInBody('/assets/javascript/ext-language_tools.js')
    loadScriptInBody.loadScriptInBody('/assets/javascript/ext-static_highlight.js')
  })
}
/**
 * Eject the code editor
 */
const ejectAce = () => {
  if (window.ace) {
    loadScriptInBody.unloadScriptInBody('/assets/javascript/ace.min.js')
    loadScriptInBody.unloadScriptInBody('/assets/javascript/ext-language_tools.js')
    loadScriptInBody.unloadScriptInBody('/assets/javascript/ext-static_highlight.js')
    window.ace = null
  }
}

export default {
  injectAce,
  ejectAce,
  cleanIdeStore
}
